var LoadJS = /** @class */ (function () {
    function LoadJS() {
    }
    /*public getJSON(url, successHandler, errorHandler) {
     let xhr = new XMLHttpRequest();
     xhr.open('get', url, true);
     xhr.responseType = 'json';
     xhr.onload = function () {
     let status = xhr.status;
     if (status == 200) {
     successHandler && successHandler(xhr.response); // jshint ignore:line
     } else {
     errorHandler && errorHandler(status); // jshint ignore:line
     }
     };
     xhr.send()
     }*/
    // jshint ignore:start
    LoadJS.prototype.loadSync = function (file) {
        var element = document.createElement('script');
        element.src = file;
        element.setAttribute('async', 'true');
        document.body.appendChild(element);
    };
    return LoadJS;
}());
//# sourceMappingURL=loadJS.js.map